module.exports = __webpack_public_path__ + "img/experience.adff01e9.png";